import React from 'react';
import './Styles/Content.scss';
import {IoMdArrowDropdown,IoMdArrowDropup} from 'react-icons/io';
import { useState } from 'react';
import { list1, sections } from './data';
import Section from '../Monzo/Section';
const Content =()=>{
    const [get,setGet] = useState(false);
    const [auth,setAuth] = useState(false);
    const [tutorials,setTutorials] = useState(false);
    const [image,setImage] = useState(false);
    const [arrange,setArrange] = useState(false);
    
    function open1(){
        setGet(!get)
    }
    function open2(){
        setAuth(!auth)
    }
    function open3(){
        setTutorials(!tutorials)
    }
    function open4(){
        setImage(!image)
    }
    function open5(){
        setArrange(!arrange)
    }
    return(
        <div className="content-developer">
            <div className="links-part">
                <h2>Content</h2>
                <div className="links">
                    <p>Intro</p>
                    <p onClick={open1}>Get Started {get===false ? <IoMdArrowDropdown /> : <IoMdArrowDropup />} </p>
                    {get===true &&
                    <div className="content content1">
                        <ul>
                          {list1.map((item) =>{
                              return(
                                  <li>{item}</li>
                              )
                          })}
                        </ul>
                    </div>
                    }
                    <p onClick={open2}>Authentication {auth===false ? <IoMdArrowDropdown /> : <IoMdArrowDropup />} </p>
                    {auth===true &&
                    <div className="content content1">
                        <ul>
                          {list1.map((item) =>{
                              return(
                                  <li>{item}</li>
                              )
                          })}
                        </ul>
                    </div>
                    }
                    <p onClick={open3}>Tutorials {tutorials===false ? <IoMdArrowDropdown /> : <IoMdArrowDropup />} </p>
                    {tutorials===true &&
                    <div className="content content1">
                        <ul>
                          {list1.map((item) =>{
                              return(
                                  <li>{item}</li>
                              )
                          })}
                        </ul>
                    </div>
                    }
                    <p onClick={open4}>Image Uploads {image===false ? <IoMdArrowDropdown /> : <IoMdArrowDropup />} </p>
                    {image===true &&
                    <div className="content content1">
                        <ul>
                          {list1.map((item) =>{
                              return(
                                  <li>{item}</li>
                              )
                          })}
                        </ul>
                    </div>
                    }
                    <p onClick={open5}>Arrange Screens {arrange===false ? <IoMdArrowDropdown /> : <IoMdArrowDropup />} </p>
                    {arrange===true &&
                    <div className="content content1">
                        <ul>
                          {list1.map((item) =>{
                              return(
                                  <li>{item}</li>
                              )
                          })}
                        </ul>
                    </div>
                    }
                    <p>Embeds</p>
                    <p>Pagination</p>
                    <p>Terms of Use</p>
                    <p>Contact Us</p>
                </div>
            </div>
            <div className="data">
               {sections.map((d) =>{
                   return(
                       <Section {...d}/>
                   )
               })}
               <div className="card">
                   <p>curl \</p>
                   <ul>
                       <li> -H "Authorization: Bearer {"<token>"} \ </li>
                       <li>-H "Content-Type: application/json" \</li>
                       <li>-X POST -d '{'{ "query": "query getUser { user { email username } }" ""}'}' \</li>
                       <li>https://api.hostdesign.com/graphql/</li>
                   </ul>
               </div>
               <Section 
               title="Introspecting the schema"
               desc="One of the GraphQL's benefits is that it's introspective, if you've ever used a poorly documented REST API you'll appreciate straight away the need for this. No more traipsing through incomplete or unmaintained docs, if you want to see the whole schema (the same data the GraphiQL sandbox uses to suggest / autocomplete), use the following query:"
               />
                  <div className="card">
                   <p>{"query {"}</p>
                   <ul>
                       <li>{"__schema {"}</li>
                       <li>name</li>
                       <li>kind</li>
                     <li>description</li>
                     <li>{"fields {"}</li>
                     <li>name</li>
                     <li>{"}"}</li>
                     <li>{"}"}</li>
                     <li>{"}"}</li>
                     <li>{"}"}</li>

                   </ul>
               </div>
               <Section 
               desc="One of the GraphQL's benefits is that it's introspective, if you've ever used a poorly documented REST API you'll appreciate straight away the need for this. No more traipsing through incomplete or unmaintained docs, if you want to see the whole schema (the same data the GraphiQL sandbox uses to suggest / autocomplete), use the following query:"
               />
            </div>
        </div>
    )
};
export default Content ;